/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from 'react';
import './authenticator.scss'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Divider, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { googleAuthAndriod, googleAuthIos, microsoftAuthAndriod, microsoftAuthIos } from '../../constants/commonConstants';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export const Authenticator: React.FC<any> = ({ openPopupAuth, closeCallback }) => {
  const [openPopup, setOpenPopup] = React.useState(openPopupAuth);

  const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const { children, onClose, ...other } = props;

    return (
      <div>
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
          {children}
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      </div>
    );
  };

  const closeRoles = (showMsg: any = false) => {
    setOpenPopup(false);
    closeCallback(false);
  };


  const openInNewTab = (link: any) => {
    window.open(link, '_blank');
  }

  return (
    <>
      <div >
        <BootstrapDialog
          aria-labelledby="customized-dialog-title"
          open={openPopup}
        >
          <div className="authPopupWrapper">
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={closeRoles}
            >
              <span className='titleText'> Compatible authenticators</span>
            </BootstrapDialogTitle>
            <Divider />
            <div className='tableWrapper'>
              <div className='authWrapper'>
                <div className='imgDiv'>
                  <img alt=""
                    src={require("../../assets/images/gauth.png")}
                  />
                </div>
                <div className='authDetails'>
                  <span className='authTitle' >
                    Google Authenticator
                  </span>
                  <div className='authAIButtons'>
                    <span className='authSubTitle' style={{ paddingRight: '10px' }} onClick={() => openInNewTab(googleAuthAndriod)}>
                      Android
                    </span>
                    <span className='authSubTitle rightIos' onClick={() => openInNewTab(googleAuthIos)}>
                      iOS
                    </span>
                  </div>
                </div>
              </div>
              <div className='authWrapper middleDiv'>
                <div className='imgDiv'>
                  <img alt="" className='mImg'
                    src={require("../../assets/images/mauth.png")}
                  />
                </div>
                <div className='authDetails'>
                  <span className='authTitle' >
                    Microsoft Authenticator
                  </span>
                  <div className='authAIButtons'>
                    <span className='authSubTitle' style={{ paddingRight: '10px' }} onClick={() => openInNewTab(microsoftAuthAndriod)}>
                      Android
                    </span>
                    <span className='authSubTitle rightIos' onClick={() => openInNewTab(microsoftAuthIos)}>
                      iOS
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BootstrapDialog>
      </div>
    </>
  );
}